export const state = {
  appTitle: 'PinLabs Inc.',
  user: null,
  error: null,
  loading: false
}



// WEBPACK FOOTER //
// ./src/store/state.js